import React, { Component } from 'react';

class NoCountry extends Component{
  render() {
    return (
      <div className="modal fade" id="noCountry">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <h4 className="modal-title">
                <i className="fa fa-exclamation-circle" /> &nbsp;Information Tips
              </h4>
            </div>
            <div className="modal-body">
              <div className="alert alert-block">
                <p>Please select one or more countries</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NoCountry;


// WEBPACK FOOTER //
// ./src/component/alert/noCountry.js